import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  SxProps,
  Theme,
  Radio,
} from "@mui/material";
import { Item } from "../../modules/users/components/UserItemsTable";
import CardBox from "./CardBox";

export default function SelectItemTable(props: {
  items: Item[];
  selectedItem?: Item;
  setSelectedItem: (item: Item) => void;
  sx?: SxProps<Theme>;
}) {
  const { items, sx, setSelectedItem, selectedItem } = props;
  const toggleItem = (item: Item) => {
    setSelectedItem(item);
  };

  return (
    <CardBox sx={{ width: "100%" }}>
      <TableContainer
        sx={
          sx ?? {
            maxHeight: "300px",
            overflow: "auto",
          }
        }
      >
        <Table size="small" stickyHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell align="center">
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Nenhum item encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {items.map((item) => {
              return (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    align="left"
                  >
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Radio
                      sx={{
                        width: {
                          xs: "25px",
                        },
                        height: {
                          xs: "25px",
                        },
                        marginLeft: {
                          xs: "auto",
                          sm: "10px",
                        },
                      }}
                      checked={selectedItem?.id === item.id}
                      onClick={() => toggleItem(item)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </CardBox>
  );
}
